class ProductSelector extends OptionsSelector {
  constructor() {
    super();
    this.productMedia = document.querySelector(
      `product-media[data-section-id="${this.sectionId}"]`,
    );
    this.productBar = document.querySelector('product-bar');
    this.plans = this.querySelector('[data-plans]');
    this.purchaseOptions = JSON.parse(
      this.querySelector('[data-purchase-options]').textContent,
    );
    this.defaultVariant = this.querySelector('[data-initial-gallery]')
  }

  connectedCallback() {
    if (this.inputId.value === '') return;
    this.onOptionChange();
    this.initPlans();
    if (!this.defaultVariant) return;
    this.updateMedia(this.defaultVariant.dataset.initialGallery);

    // Add event listener for click events on radios and swatches
    document.addEventListener('click', this.updateAtcPrice.bind(this));

    // Initialize the MutationObserver for observing the button changes
    this.updateAtcPriceObserver();

    // Apply the correct price immediately after the page loads
    setTimeout(() => {
      this.updateAtcPrice();
    }, 1111);

    // Apply the correct price again much later for slow browsers
    setTimeout(() => {
      this.updateAtcPrice();
    }, 9999); // Run after 10 seconds for slower browsers
  }

  updateAtcPriceObserver() {
    const productAtcButton = document.querySelector('.product-selector__submit'); // Get the add to cart button

    if (productAtcButton) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            // Run the updateAtcPrice function once a mutation is observed
            this.updateAtcPrice();
          }
        });
      });

      // Start observing the button for attribute and child changes
      observer.observe(productAtcButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  }

  updateAtcPrice() {
    setTimeout(() => {
      const activeRadio = document.querySelector('.rc-radio--active'); // Get the active radio button
      const priceLabel = activeRadio?.querySelector('.price-label'); // Get the price label
      const productAtc = document.querySelector('.product-bar .product-bar__submit'); // Get the add to cart button
      const productAtcSticky = document.querySelector('.product-selector__submit'); // Get the sticky add to cart button

      // Proceed only if all necessary elements exist and the price value is available
      if (activeRadio && priceLabel && productAtc && productAtcSticky) {
        const priceValue = priceLabel.textContent.trim(); // Get the price value

        // Update the add to cart buttons only if the price has changed
        if (productAtc.textContent !== `Add to cart ${priceValue}`) {
          productAtc.textContent = `Add to cart ${priceValue}`;
        }

        // Update the sticky add to cart button only if the price has changed
        if (productAtcSticky.textContent !== `Add to cart ${priceValue}`) {
          productAtcSticky.textContent = `Add to cart ${priceValue}`;
        }
      }
    }, 0);
  }

  onOptionChange(e) {
    if (e?.target?.type === 'number') {
      if (!this.productBar) return;
      this.productBar.updateQuantity(e.target.value);
      return;
    }
    super.onOptionChange(e);
    if (e?.target?.name === 'properties[shipping_interval_frequency]') {
      this.togglePlan(true);
    }
    if (e?.target?.name === 'purchase_type') {
      this.togglePlan(e.target.value === 'autodeliver');
    }
    if (
      !e ||
      e.target.name === 'purchase_type' ||
      e.target.name === 'properties[shipping_interval_frequency]'
    )
      return;
    this.updateSelected(e.target);
    this.updateMedia(e.target.value);
    this.updateURL();
    this.initPlans();
    this.renderBarOptions();
  }

  updateSelected({ name, value }) {
    const selected = this.querySelector(`[data-selected="${name}"]`);
    if (!selected) return;
    selected.parentElement.classList.remove('hidden');
    selected.textContent = value;
  }

  updateMedia(value) {
    if (!this.productMedia) return;
    this.productMedia.setActiveMedia(value);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  renderBarOptions() {
    if (!this.productBar) return;
    this.productBar.renderTitle(this.options);
  }

  setUnavailable() {
    super.setUnavailable();
    this.plans?.classList?.add('hidden');
  }

  togglePlan(subscription) {
    if (subscription) {
      this.setPlan();
      return;
    }

    this.setPlan(true);
  }

  initPlans() {
    if (!this.plans || !this.currentVariant) return;
    this.plans.classList.remove('hidden');
    this.setPlan(true);
  }

  setPlan(clear = false) {
    const oneTimeRadio = this.querySelector(
      '[name="purchase_type"][value="onetime"]',
    );
    const subscriptionRadio = this.querySelector(
      '[name="purchase_type"][value="autodeliver"]',
    );
    const subscriptionInterval = this.querySelector(
      '[name="properties[shipping_interval_frequency]"]',
    );
    const subscriptionIntervalUnitType = this.querySelector(
      '[name="properties[shipping_interval_unit_type]"]',
    );
    oneTimeRadio.checked = clear;
    subscriptionRadio.checked = !clear;
    subscriptionInterval.disabled = clear;
    subscriptionIntervalUnitType.disabled = clear;
    !clear && this.pickDiscountedVariant();
    this.plans.classList.toggle('selected-onetime', clear);
  }

  pickDiscountedVariant() {
    const activeSubscription = this.querySelector(
      '[name="purchase_type"][value="autodeliver"]:checked',
    );
    if (!this.purchaseOptions?.has_subscription || !activeSubscription) return;
    this.discountedVariant =
      this.purchaseOptions.original_to_hidden_variant_map[
      this.currentVariant.id
      ];
    this.updateVariantInput(this.discountedVariant.discount_variant_id);

    const destinationPrices = document.querySelectorAll(
      `[data-discounted-variant-price]`,
    );

    const discountedPrice = Shopify.money_format.replace(
      '{{amount}}',
      this.discountedVariant.discount_variant_price,
    );

    destinationPrices.forEach((container) => {
      container.classList.remove('visually-hidden');
      container.textContent = discountedPrice;
    });

    if (this.currentVariant.available) {
      this.submitButton.disabled = false;
      this.submitButton.textContent = `${window.variantStrings.addToCart} ${discountedPrice}`;
      if (this.productBarSubmitButton) {
        this.productBarSubmitButton.disabled = false;
        this.productBarSubmitButton.textContent = `${window.variantStrings.addToCart} ${discountedPrice}`;
      }
    }
  }
}

customElements.define('product-selector', ProductSelector);
